import { fetchAction, GENERIC_ERROR, isValidEmail } from '../utilities'
import { createTurnstile } from '../turnstile'

const SUBSCRIBE_ACTION = '/actions/expansion/email-signup/subscribe'
const CLICK_ACTION = '/actions/expansion/turkey-rot/click'

const DEFAULT_SUCCESS = "You're on the list."

/**
 * Generic email signup block.
 *
 * Two modes, picked in the CMS:
 *
 *   plain     — subscribe to the block's Iterable list, then say so inline.
 *   campaign  — post to the Turkey Rot click endpoint instead, so the sign-up
 *               also moves the donation total, spends a click from the daily
 *               budget and lands on the confirmation page. `campaignEntryId`
 *               is the header entry that carries the campaign numbers; the
 *               server reads them off it and never trusts anything here.
 */
export const emailSignup = (config = {}) => ({
	entryId: config.entryId ?? null,
	campaignEntryId: config.campaignEntryId ?? null,
	csrfToken: config.csrfToken ?? '',
	turnstileSiteKey: config.turnstileSiteKey ?? '',
	redirectUrl: config.redirectUrl ?? '',
	successMessage: config.successMessage || DEFAULT_SUCCESS,

	email: '',
	loading: false,
	done: false,
	error: null,
	message: '',

	turnstile: null,

	get isCampaign() {
		return this.campaignEntryId !== null
	},

	async submit() {
		if (this.loading || this.done) {
			return
		}

		const address = this.email.trim()

		// Catch obvious typos before spending a Turnstile token on them.
		if (!isValidEmail(address)) {
			this.error = 'email'
			this.message = 'Please enter a valid email address.'

			return
		}

		this.loading = true
		this.error = null
		this.message = ''

		const turnstileToken = await this.turnstile(this.$refs.turnstile)

		const response = await fetchAction(
			this.isCampaign ? CLICK_ACTION : SUBSCRIBE_ACTION,
			'POST',
			this.csrfToken,
			JSON.stringify({
				entryId: this.isCampaign ? this.campaignEntryId : this.entryId,
				turnstileToken,
				email: address,
			}),
		)

		this.loading = false

		if (!response.isSuccessful) {
			this.error = 'network'
			this.message = GENERIC_ERROR

			return
		}

		const data = response.successData ?? {}

		if (!data.success) {
			this.error = data.error ?? 'unknown'
			this.message = data.message ?? GENERIC_ERROR

			return
		}

		if (this.redirectUrl) {
			// Let the success message land before leaving the page.
			this.done = true
			this.message = this.successMessage

			window.setTimeout(() => {
				window.location.href = this.redirectUrl
			}, 900)

			return
		}

		this.done = true
		this.email = ''
		this.message = this.successMessage
	},

	init() {
		this.turnstile = createTurnstile(this.turnstileSiteKey)
	},
})
